import { css } from "@emotion/react";
import { COLOR_WHITE } from "../constants/styles";

export const CSS_CARD = css`
  background: ${COLOR_WHITE};
  box-shadow: 0 13px 18px rgba(57, 84, 255, 0.04);
  border-radius: 12px;
`;
